export default __webpack_public_path__ + "static/media/FrontCover.efff1006.txt";